import {
  PatchApiSpoSmBody,
  SpoPersonalOfferTableResponse,
  SpoUpdateSmResponse,
} from '@spo/types';
import { apiBff } from '.';
import { mapIdColumn } from '../utils';

export const getUrlParam = (value: string[] | number[], paramName: string) =>
  value.length ? `&${paramName}=${value}` : '';

export const getSMPath = (
  offerDate: string,
  filters: {
    productManagerIds: string[];
    productNatureIds: number[];
    retailFamilyIds: number[];
    segmentationIds: number[];
    sportIds: number[];
  },
  smIds: string[],
  columnSort: { id: string; order: string },
  range: {
    start: number | null;
    end: number | null;
  } = { start: 0, end: 9 },
): string => {
  const sortParameters =
    columnSort?.order !== ''
      ? `&sort=${mapIdColumn(columnSort?.id)},${columnSort?.order}`
      : '';

  const builtUrlParams = `${getUrlParam(
    filters.productNatureIds,
    'product_nature_ids',
  )}${getUrlParam(filters.retailFamilyIds, 'retail_family_ids')}${getUrlParam(
    filters.productManagerIds,
    'product_manager_uids',
  )}${getUrlParam(filters.segmentationIds, 'segmentation_value_ids')}`;

  const dateParams = `&offer_date=${offerDate}`;
  //Set Range to 0-99 when it's mass edit
  const rangeParams =
    smIds.length > 0 ? '&range=0-99' : `&range=${range.start}-${range.end}`;
  const idsParams = `${getUrlParam(smIds, 'ids')}`;
  return `sport_ids=${filters.sportIds}${builtUrlParams}${dateParams}${rangeParams}${sortParameters}${idsParams}&type=PASSION`;
};

export const getSMParams = (
  smPath: string,
): {
  offerDate: string;
  filters: {
    productManagerIds: string[];
    productNatureIds: number[];
    retailFamilyIds: number[];
    segmentationIds: number[];
    sportIds: number[];
  };
  smIds: string[];
  columnSort: {
    id: string;
    order: string;
  };
  range: { start: number; end: number };
} => {
  const params = new URLSearchParams(smPath);

  const offerDate = params.get('offer_date') || '';
  // filters
  const productManagerIds =
    params.get('product_manager_uids')?.split(',') || [];
  const productNatureIds =
    params
      .get('product_nature_ids')
      ?.split(',')
      .map((value) => parseInt(value)) || [];
  const retailFamilyIds =
    params
      .get('retail_family_ids')
      ?.split(',')
      .map((value) => parseInt(value)) || [];
  const segmentationIds =
    params
      .get('segmentation_value_ids')
      ?.split(',')
      .map((value) => parseInt(value)) || [];
  const sportIds =
    params
      .get('sport_ids')
      ?.split(',')
      .map((value) => parseInt(value)) || [];

  const filters = {
    productManagerIds,
    productNatureIds,
    retailFamilyIds,
    segmentationIds,
    sportIds,
  };

  const smIds = params.get('ids')?.split(',') || [];
  const columnSort: { id: string; order: string } = {
    id: params.get('sort')?.split(',')[0] || '',
    order: params.get('sort')?.split(',')[1] || '',
  };

  const range: { start: number; end: number } = {
    start: parseInt(params.get('range')?.split('-')[0] || ''),
    end: parseInt(params.get('range')?.split('-')[1] || ''),
  };
  return { offerDate, filters, smIds, columnSort, range };
};

export type PersonalOfferParams = {
  filters: {
    productManagerIds: string[];
    productNatureIds: number[];
    retailFamilyIds: number[];
    segmentationIds: number[];
    sportIds: number[];
  };
  smIds: string[];
  columnSort: { id: string; order: string };
  offerDate?: string;
  range?: {
    start: number | null;
    end: number | null;
  };
};

export const getPersonalOfferSM = async ({
  filters,
  smIds,
  columnSort,
  offerDate = '',
  range,
}: PersonalOfferParams): Promise<SpoPersonalOfferTableResponse> => {
  const smPath = getSMPath(offerDate, filters, smIds, columnSort, range);
  return apiBff.callBFF('POST', 'spo/personal_offer_table', {
    range,
    smPath,
  });
};

export const updateSuperModels = async (
  patchApiSpoSmBody: PatchApiSpoSmBody,
): Promise<SpoUpdateSmResponse> =>
  apiBff.callBFF('PATCH', 'spo/sm', patchApiSpoSmBody);
